export const sportsLink: string = '/sports/';
